import { type FC } from 'react';

type BaseRoleInfoProps = {
  baseRole: string;
  className?: string;
};

export const BaseRoleInfo: FC<BaseRoleInfoProps> = ({ baseRole, className = '' }) => (
  <div className={`consolidationModal__baseRoleInfo ${className}`}>
    <div className="consolidationModal__baseRoleTitle">ℹ️ Built-in Role: {baseRole}</div>
    <div className="consolidationModal__baseRoleText">
      This user has a built-in role of <strong>{baseRole}</strong>. All permissions listed in the policy below will be
      in addition to the built-in role permissions.
    </div>
  </div>
);
